import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as contexts from '../../contexts'
import type { TypeParams } from '../types'

/**
 * Refreshes scoped Users tabs after creating a user because tenant-level
 * creation can also create or reuse access assignments returned only by the
 * scoped users queries.
 */
export const refreshUsersOnCreateSuccess = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    usersEc: ec.Collection<TypeParams>,
    contexts: contexts.Feature,
  ) =>
    usersEc.plugins.dataOperationPlugin.feature.actions.create.success
      .observe()
      .pipe(
        rxjsUtils.latestFrom(
          () => contexts.selectors.activeEntityContext.asObservable,
        ),
        rxjs.filter(context => context !== undefined),
        rxjs.map(() =>
          usersEc.plugins.currentListPlugin.feature.actions.load
            .from('refreshUsersOnCreateSuccess (effect)')
            .create(),
        ),
      ),
)
